/*
 *   File : auth-layout.jsx
 *   Author : https://evoqins.com
 *   Description : Layout page for authentication
 *   Integrations :
 *   Version : 1.0.0
 */
import React from "react";
import { Outlet } from "react-router-dom";

//custom component
import { Footer } from "../../Components/Navigation/index";

export default function AuthLayout() {
  return (
    <div className="row">
      <div className=" offset-xxl-2 offset-xl-2 offset-1 col-xxl-8 col-xl-8 col-10">
        <div className="row pb-4">
          <div className="e-auth-sidebar d-xl-block d-lg-block d-none col-6 e-auth-side-gradient rounded-start-5 overflow-hidden">
            <div className="row e-p-56px ">
                <div className="row">
                  <div className="col-8">
                    <img
                      src={require("../../Assets/Image/logo-inverse.png")}
                      alt="GrowthVine"
                      className=" img-fluid"
                    />
                  </div>
                </div>
              <div className="row pt-3">
                <div className="col-xxl-10 col-12">
                  <h2 className="e-text-key-lime display-6">
                    Your wealth, Your Identity.
                  </h2>
                </div>
              </div>
            </div>
            {/* //sidebar-img */}
            <img
              src={require("../../Assets/Image/auth-side.gif")}
              className="img-fluid pb-1 object-fit-cover e-login-banner"
              alt="Your wealth,Your Identity."
              // style={{height:"280px"}}
            />
          </div>
          <div className="col-xl-6 col e-auth-outlet-wrapper rounded-end-5 e-bg-floral-white px-5 ">
            <Outlet />
          </div>
        </div>
        <Footer type1={1} />
      </div>
    </div>
  );
}
